import {useParams} from 'react-router-dom';

import {Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';
import TransactionTable from '@/screens/Transaction/List/TransactionTable';
import type {AfriexAdminTransaction} from '@/types';

import useTierTransactionList from './useTierTransactionList';

const TierTransactionList = () => {
  const params = useParams();
  const tierId = params?.tierId || '';
  const {isLoading, fetchList, total, list} = useTierTransactionList(tierId);

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <section className="pt-5 md:pt-5">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <TransactionTable items={list as AfriexAdminTransaction[]} />
        )}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={total}
          isSearch={false}
        />
      ) : null}
    </main>
  );
};

export default TierTransactionList;
